import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { LESSON_STATUS } from '../../../typings';

export type MonthLessonsResponse = { date: number; status: LESSON_STATUS }[];

export function getMonthLessons(
    courseId: number,
    params: {
        start_date: number;
        end_date: number;
        timezone?: number;
    }
): Promise<MonthLessonsResponse> {
    const { apiGetMonthLessons } = apiConfig.getStaticUrls();

    return getFetch(`${apiGetMonthLessons}${courseId}/`, params);
}
